import { ContractingStatusColorEnum, OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { FiltersType, IOnlineContractingState } from './types';

export const filtersInitialState: FiltersType = {
  cpf: '',
  rowsPerPage: 20,
  page: 0,
  finalDate: undefined,
  startDate: undefined,
  status: undefined,
  name: '',
  cancellationStatus: undefined,
};

export const onlineContractingInitialState: IOnlineContractingState = {
  paymentDetails: {
    paymentId: '',
    orderId: '',
    totalValue: 0,
    paymentStatus: '',
    buyer: { fullName: '', cpf: '' },
    shippingValue: 0,
    items: [],
    address: {
      cityState: '',
    },
    device: {
      imei: '',
    },
    history: [],
  },
  list: {
    items: [],
    count: 0,
  },
  contractingKey: '',
  contractingState: OnlineContractingStateEnum.ContractingStarted,
  filter: filtersInitialState,
  statusColor: ContractingStatusColorEnum.undefined,
};
